
import { Load } from '../../types';

// Ground floor loads
export const groundFloorLoads: Load[] = [
  {
    id: '1',
    name: 'Reception Lights',
    type: 'lighting',
    status: true, // true = on, false = off
    location: 'Reception',
    powerRating: '120W',
    currentConsumption: '110W',
    schedules: [
      {
        id: '1-1',
        days: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'],
        startTime: '18:00',
        endTime: '23:00',
        enabled: true,
      }
    ],
    recommendations: [
      {
        id: '1-rec-1',
        description: 'Replace with LED lights to save 40% energy',
        potentialSavings: '48W',
        priority: 'high'
      },
      {
        id: '1-rec-2',
        description: 'Reduce lighting hours by 1 hour daily',
        potentialSavings: '15kWh/month',
        priority: 'medium'
      }
    ]
  },
  {
    id: '3',
    name: 'Meeting Room TV',
    type: 'entertainment',
    status: false,
    location: 'Meeting Room A',
    powerRating: '250W',
    currentConsumption: '0W',
    schedules: [],
    recommendations: [
      {
        id: '3-rec-1',
        description: 'Enable auto-shutdown after hours',
        potentialSavings: '25kWh/month',
        priority: 'medium'
      }
    ]
  }
];
